export default {
  name: 'textarea',
  type: 'action',
  isRequired: true,
  essential: false
}
